import { Popper, PopperProps } from '@mui/material';

interface FixedWidthPopperProps extends PopperProps {
  width?: string | number;
}

export const FixedWidthPopper = function ({ width = '320px', style, ...props }: FixedWidthPopperProps) {
  return <Popper {...props} style={{ ...style, width }} />;
};
